import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import MultiSelectBox from '../../../../../../features/components/Form/MultiSelectBox'

import { formatOptionsList } from '../../../../../../features/formatters'

import { choicesPixelsLoadingSelector, choicesPixelsSelector } from '../../../../../../modules/selectors/choices'
import { clearChoicesPixels, getChoicesPixels } from '../../../../../../modules/actions/choices'
import { clearPixelStats } from '../../../../../../modules/actions/lineItems'
import { selfAccountSelector } from '../../../../../../modules/selectors/selfAccounts'
import { partnershipsSelector } from '../../../../../../modules/selectors/partnerships'

import { FACEBOOK_PLATFORM, FACEBOOK_PROVIDER_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { DATASETS, PROVIDER } from '../fields'

import useDrawerFormClasses from '../../../../../../styles/common/drawerForms'

export const providersOptions = [
  // For now, we only support facebook in this form
  { label: 'Meta', value: FACEBOOK_PROVIDER_PLATFORM }
]

const DatasetsSection = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  const dispatch = useDispatch()

  const pixels = useSelector(choicesPixelsSelector)
  const choicesPixelsLoading = useSelector(choicesPixelsLoadingSelector)
  const partnerships = useSelector(partnershipsSelector)
  const selfAccount = useSelector(selfAccountSelector)

  const partnershipOfPartnerAccount = useMemo(() => {
    return partnerships.find(item => {
      return item.partner === selfAccount.id && item.rights_holder === selfAccount.parent_right_holder
    })
  }, [partnerships, selfAccount.id, selfAccount.parent_right_holder])

  const partnershipFacebookAccountId = partnershipOfPartnerAccount?.facebook_ad_account?.external_id

  const { values, setFieldValue } = formik

  const formattedPixels = useMemo(
    () =>
      formatOptionsList({
        list: pixels,
        labelName: 'name',
        valueName: 'id'
      }),
    [pixels]
  )
  useEffect(() => {
    if (partnershipFacebookAccountId) {
      dispatch(getChoicesPixels({ account: partnershipFacebookAccountId }, FACEBOOK_PLATFORM))
    }
  }, [dispatch, partnershipFacebookAccountId])

  useEffect(
    () => () => {
      dispatch(clearChoicesPixels())
      dispatch(clearPixelStats())
    },
    [dispatch]
  )

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Datasets')}</h3>

      <Field options={providersOptions} formik={formik} id={PROVIDER} name={PROVIDER} placeholder={t('Platform')} />

      <MultiSelectBox
        name={DATASETS}
        options={formattedPixels}
        value={values[DATASETS]}
        isLoading={choicesPixelsLoading}
        setFieldValue={setFieldValue}
      />
    </section>
  )
}

export default DatasetsSection
